import { instantFns, zonedDateTimeFns } from 'iso-fns2'

const patternMap = {
  'MM/DD/YYYY': /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
  'yyyy-mm-dd': /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/
}

const MIN_AGE = 18

const MAX_AGE = 98

export const validateDateFormat = (date, format = 'MM/DD/YYYY') => {
  return patternMap[format].test(date)
}

export const minAgeCheck = (date) => {
  return instantFns.isBefore(
    new Date(date).toISOString(),
    zonedDateTimeFns.toInstant(zonedDateTimeFns.subtract(zonedDateTimeFns.now(), { years: MIN_AGE }))
  )
}

export const maxAgeCheck = (date) => {
  return instantFns.isAfter(
    new Date(date).toISOString(),
    zonedDateTimeFns.toInstant(zonedDateTimeFns.subtract(zonedDateTimeFns.now(), { years: MAX_AGE }))
  )
}

export const subtractYearsFromDate = (date, years) => {
  return date
    ? new Date(new Date(date).setFullYear(new Date(date).getFullYear() - years)).toISOString()
    : zonedDateTimeFns.toInstant(zonedDateTimeFns.subtract(zonedDateTimeFns.now(), { years: years }))
}
